import { render } from "./BuyRentMsisdnDialog.vue?vue&type=template&id=37b97cf2"
import script from "./BuyRentMsisdnDialog.vue?vue&type=script&lang=js"
export * from "./BuyRentMsisdnDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__